/**
 * Settings that affect price-map / arg-keyed sourcing context (not branch).
 * `active_branch` is handled separately via `BRANCH_SOURCING_CACHE_TAGS`
 */
const SOURCING_CONTEXT_SETTING_KEYS = [
  'sourcing_buyer_country',
  'sourcing_currency',
  'sourcing_pricing_strategy',
] as const;

export type SourcingContextSettingKey = (typeof SOURCING_CONTEXT_SETTING_KEYS)[number];

export const isSourcingContextSettingKey = (
  settingKey: string
): settingKey is SourcingContextSettingKey => SOURCING_CONTEXT_SETTING_KEYS.includes(settingKey);
